import React, { useState, useEffect } from 'react';
import Sidebar from '../../common/components/Sidebar/Sidebar';
import Header from '../../common/components/Header/Header';
import CustomSideBar from '../../common/components/Sidebar/Sidebar';
import Helmet from 'react-helmet';
import { siteTitle } from '../../../data/SiteConfig';
import applicant from '../../images/icons/applicant.svg';
import Stepper from '../../components/Stepper/Stepper';
import sideImage from '../../images/icons/KYCComplete.svg';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import {
  requestCreditReport,
  getLeadProfileStatus
} from '../../common/constants/api';
import PopUp from '../../common/components/PopUp/PopUp';
import { getApplicantionInfo } from '../../common/utils/applicantionInfo';
import _ from 'lodash';
import { navigate } from 'gatsby';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';

const RequestCreditReport = () => {
  const [nextPage, setNextPage] = useState('');
  const [applicantInformation, setApplicantInformation] = useState(false);
  const [step, setStep] = useState('send_req');
  const applicantClick = () => {
    navigate(`/app/leadprofile`);
  };

  useEffect(() => {
    setApplicantInformation(
      localStorage.hasOwnProperty('ApplicantUserKycInfo')
        ? JSON.parse(localStorage.getItem('ApplicantUserKycInfo'))
        : false
    );
  }, []);
  let stepsText = ['KYC', 'Income', 'Property'];
  const icons = {
    1: <div className="text-lg">1</div>,
    2: <div className="text-lg">2</div>,
    3: <div className="text-lg">3</div>
  };
  const statePara = {
    setStep: setStep
  };

  useEffect(() => {
    let url = new URL(window.location.href);
    let step = url.searchParams.get('step');
    if (step == 'lap') setNextPage('/app/LAP/income');
    else setNextPage('/app/income');
  }, []);

  return (
    <React.Fragment>
      <Helmet title={`credit report | ${siteTitle}`} />
      <div className="bg-grey-950 relative h-full overflow-auto font-roboto text-sm font-normal m-0 p-0">
        <div className=" min-h-screen flex pt-17 md:pt-0">
          <CustomSideBar />
          <div className="flex-1  w-full widhtMd max-screen">
            <Header />
            <div className="flex-1 pb-8 flex-row w-full relative">
              <div className="w-full flex">
                <div className="md:ml-5  w-full md:w-8/12 px-2 md:bg-white min-h-screen md:py-2">
                  <div
                    className="w-12 px-1 py-1 text-center cursor-pointer"
                    onClick={applicantClick}
                  >
                    <img
                      className="mr-auto w-full  rounded-md"
                      src={applicant}
                    />
                    <p
                      className="font-roboto font-normal text-black-500 mx-auto"
                      style={{ fontSize: '10px' }}
                    >
                      {applicantInformation.name
                        ? `${applicantInformation.name.firstName} ${applicantInformation.name.lastName}`
                        : 'Applicant'}
                    </p>
                  </div>
                  <div className="overflow-x-auto">
                    <Stepper
                      activeStep={1}
                      stepsText={stepsText}
                      stepIcons={icons}
                    />
                  </div>
                  <div className="w-full px-3">
                    {step == 'send_req' ? (
                      <SendCreditReportRequest
                        statePara={statePara}
                        nextPage={nextPage}
                      />
                    ) : null}
                    {step == 'req_sent' ? (
                      <RequestSentPage
                        statePara={statePara}
                        nextPage={nextPage}
                      />
                    ) : null}
                  </div>
                </div>

                <div className="w-1/4 hidden md:block">
                  <img
                    className="inset-x-0 bottom-0"
                    src={sideImage}
                    style={{ position: 'fixed', bottom: 0, left: '80%' }}
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withErrorHandler(RequestCreditReport);

const SendCreditReportRequest = ({ statePara, nextPage }) => {
  const [popupText, setPopUpText] = useState('Loading...');
  const [popupType, setPopUpType] = useState('loading');
  const [popUpShow, setPopUpShow] = useState(false);
  const [dontClose, setDontClose] = useState(true);
  const [autoClose, setAutoClose] = useState(true);

  useEffect(() => {
    setPopUpType('loading');
    setPopUpText('getting the status of credit report...');
    setPopUpShow(true);
    setDontClose(true);
    setAutoClose(false);

    getLeadProfileStatus(getApplicantionInfo().leadId)
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        let applicant_data = _.get(res, 'applicantsData', []);
        if (Array.isArray(applicant_data)) {
          let current_applicant = applicant_data.find(
            each => each.id == getApplicantionInfo().leadApplicantId
          );
          if (_.get(current_applicant, 'creditScore', false)) {
            navigate('/app/income');
          }
        }
        setPopUpShow(false);
      })
      .catch(error => {
        setPopUpShow(false);
      });
  }, []);

  const sendRequestForCreditReport = () => {
    setPopUpType('loading');
    setPopUpText('sending request Please Wait...!');
    setPopUpShow(true);
    setDontClose(true);
    setAutoClose(false);
    requestCreditReport(
      getApplicantionInfo().leadId,
      getApplicantionInfo().leadApplicantId
    )
      .then(res => {
        if (res.error) {
          throw new Error(res);
        }
        statePara.setStep('req_sent');
      })
      .catch(error => {
        setPopUpShow(false);
      });
  };
  return (
    <div className="flex-1 pb-8 flex-row w-full relative my-5">
      <div className="overflow-x-auto"></div>
      <div className="flex w-full">
        <p className="font-roboto font-medium text-base text-black-850 capitalize">
          credit report
        </p>
        <p
          className="font-rooto font-norml text-base text-orange-1100 float-right ml-auto capitalize cursor-pointer"
          onClick={() => navigate(nextPage)}
        >
          skip
        </p>
      </div>
      <div className="w-full  block xl:w-6/12 mx-auto mt-16">
        <p className="w-full my-2 font-roboto font-medium text-grey-2231 text-center text-base">
          Request Credit Report from Customer
        </p>
        <p className="w-full my-2 font-roboto font-normal text-grey-2232 text-center text-sm">
          Please generate and send a link to request <br /> Credit Report from
          your Customer
        </p>
      </div>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 capitalize"
        onClick={() => {
          sendRequestForCreditReport();
        }}
      >
        request & next
      </button>
      <PopUp
        type={popupType}
        text={popupText}
        setShow={setPopUpShow}
        show={popUpShow}
        dontClose={dontClose}
        autoClose={autoClose}
      />
    </div>
  );
};

const RequestSentPage = ({ statePara, nextPage }) => {
  const checkCircleStyle = {
    color: '#00ACB8',
    width: '40px',
    height: '40px',
    marginLeft: 'auto',
    marginRight: 'auto'
  };
  return (
    <div className="flex-1 pb-8 flex-row w-full relative my-5">
      <div className="overflow-x-auto"></div>
      <div className="flex w-full">
        <p className="font-roboto font-medium text-base text-black-850 capitalize">
          credit report
        </p>
      </div>
      <div className="w-full  block xl:w-6/12 mx-auto mt-16">
        <div className="mx-auto" style={{ width: '40px' }}>
          <CheckCircleIcon style={checkCircleStyle} />
        </div>
        <p className="w-full my-2 font-roboto font-medium text-grey-2231 text-center text-base">
          The Link has been sent to Customer
        </p>
        <p className="w-full my-2 font-roboto font-normal text-grey-2232 text-center text-sm">
          Your Credit Report Fetching In progress
        </p>
      </div>
      <button
        type="button"
        className="submitButton font-roboto text-white text-base w-48 capitalize"
        onClick={() => navigate(nextPage)}
      >
        next
      </button>
    </div>
  );
};
